export const getErrorCodesMap = () => import(/* webpackChunkName: "error-handler-commonErrorsMapping" */'./commonErrorsMapping');
//# sourceMappingURL=getErrorCodesMap.js.map